import { axiosInstance } from '../api';

export default function(email) {
    return axiosInstance.post('/api/auth/validateEmail', {
        'email': email
    });
}